export const initialConfig = {
	md: "",
};
